import http from "./../../services/http";

const productListParams = (page = 1, filter = "", filterBy = "product") => {
  const params = {
    page: page || 1,
  };
  const normalizedFilter = String(filter || "").trim();

  if (normalizedFilter.length > 0) {
    params[filterBy] = normalizedFilter;
  }

  return { params };
};

export const productsPaginatedRequest = (
  page = 1,
  filter = "",
  filterBy = "product"
) => {
  return http.get("products", productListParams(page, filter, filterBy));
};

export const productsMePaginatedRequest = (
  page = 1,
  filter = "",
  filterBy = "product"
) => {
  return http.get("products/all/me", productListParams(page, filter, filterBy));
};

export const productsShowRequest = (id) => {
  return http.get(`products/${id}`);
};

export const productsDeleteRequest = (id) => {
  return http.delete(`products/${id}`);
};

export const productsUpdateRequest = (payload, ean) => {
  return http.put(`products/${ean}`, payload);
};

export const productsCreateRequest = (payload) => {
  return http.post(`products`, payload);
};

export const productsImportRequest = (payload) => {
  return http.post(`products/import`, payload);
};

export const productsImagesSearchRequest = (query, limit = 12) => {
  return http.get(
    `products/images/search?q=${encodeURIComponent(query)}&limit=${limit}`
  );
};

export const productsImagesImportRequest = (payload) => {
  return http.post(`products/images/import`, payload);
};
